// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { TransportProtocolSchema } from '../inputTypeSchemas/TransportProtocolSchema'
import { ApplicationProtocolSchema } from '../inputTypeSchemas/ApplicationProtocolSchema'
import { ExternalNetworkReachabilityStatusSchema } from '../inputTypeSchemas/ExternalNetworkReachabilityStatusSchema'
import { ExternalNetworkDiscoverySourceTypeSchema } from '../inputTypeSchemas/ExternalNetworkDiscoverySourceTypeSchema'

/////////////////////////////////////////
// NETWORK SERVICE SCHEMA
/////////////////////////////////////////

export const NetworkServiceSchema = z.object({
  transportProtocol: TransportProtocolSchema,
  applicationProtocol: ApplicationProtocolSchema,
  reachabilityStatus: ExternalNetworkReachabilityStatusSchema,
  sourceType: ExternalNetworkDiscoverySourceTypeSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  hostId: z.string().nullable(),
  gatewayId: z.string().nullable(),
  port: z.number().int(),
  tlsEnabled: z.boolean(),
  banner: z.string().nullable(),
  lastReachabilityCheckedAt: z.coerce.date().nullable(),
  lastReachableAt: z.coerce.date().nullable(),
  lastUnreachableAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type NetworkService = z.infer<typeof NetworkServiceSchema>

export default NetworkServiceSchema;
